 
import PropTypes from 'prop-types';
import { Field } from 'react-final-form';
import Mentions from '../../form/inputs/Mentions';
import { ErrorWrapper } from '../../form';
import { replyFormStyle } from '../../styles/mentionInputStyle';

function CommentTextarea({ name, rows, placeholder, value, users, onMentionAdd }) {
  function Input({ input, meta }) {
    return (
      <>
        <ErrorWrapper touched={meta.touched} error={meta.error}>
          <Mentions
            {...input}
            style={replyFormStyle}
            users={users}
            name={name}
            rows={rows}
            resize={false}
            autoFocus
            placeholder={placeholder}
            onMentionAdd={onMentionAdd}
          />
        </ErrorWrapper>
      </>
    );
  }
  return <Field initialValue={value} name={name} render={Input} />;
}

CommentTextarea.defaultProps = {
  // label: undefined,
  rows: 3,
};

CommentTextarea.propTypes = {
  // label: PropTypes.string,
  name: PropTypes.string.isRequired,
  rows: PropTypes.number,
  onMentionAdd: PropTypes.func,
};

export default CommentTextarea;
